import React from 'react';
import { Box, FormPreloader } from '@common-fe/common-fe';

import FieldLevelAccessGroup from '@/modules/role/FieldLevelAccess/FieldLevelAccessGroup';
import { IFieldLevelAccessProperties } from '@/modules/role/role.types';

interface Props {
  isEditMode?: boolean;
  defaultValues?: Partial<IFieldLevelAccessProperties>;
  isLoading: boolean;
  isOverridableProperties?: boolean;

  title: string;
  testId?: string;
}

const FieldLevelAccessProperties: React.FC<Props> = ({
  isEditMode,
  defaultValues,
  isLoading,
  isOverridableProperties,
  title,
  testId,
}) => {
  return (
    <Box round="container1Round" background="canvas" pad="l" border={{ size: 'small', color: 'border1' }}>
      {isLoading ? (
        <FormPreloader testId="preloader" count={4} />
      ) : (
        <Box direction="column">
          <FieldLevelAccessGroup
            isOverridableProperties={isOverridableProperties}
            testId={testId}
            defaultExpanded
            name={title}
            items={defaultValues}
            isExternalExpandButton
            isEditMode={isEditMode}
            withDivider
            withTopBorder={false}
          />
        </Box>
      )}
    </Box>
  );
};

export default FieldLevelAccessProperties;
